import { Outlet } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ReactComponent as XchargerIcon } from '../../assets/icons/xcharger-cyan.svg';

import './auth-page.layout.scss';

const payBridgeLogo = require('../../assets/images/pay-bridge-logo-black.png');


const AuthLayout = () => {
    const { t } = useTranslation();
    return (
        <div className="auth-page-layout-container flex-column flex-align-center-center flex-gap-50" >
            <div className="header-container flex-column flex-align-center-center">
                <XchargerIcon width={350} height={200} />
                <div className="title-container">
                    <p className="title-text" style={{color:"#0f3c5f"}}> XCharger <span className="small" style={{color:"#75bef8"}}>2.0</span></p>
                </div>
            </div>
            <Outlet></Outlet>
        </div>
    );

}

export default AuthLayout;